'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$StoreAppPage(queryParams) {
  this.Sf = null;
  this.Sf = queryParams;
}
export { $c_Lmealorama_AppRouter$StoreAppPage as $c_Lmealorama_AppRouter$StoreAppPage };
$p = $c_Lmealorama_AppRouter$StoreAppPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$StoreAppPage;
/** @constructor */
function $h_Lmealorama_AppRouter$StoreAppPage() {
}
export { $h_Lmealorama_AppRouter$StoreAppPage as $h_Lmealorama_AppRouter$StoreAppPage };
$h_Lmealorama_AppRouter$StoreAppPage.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-683539911), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_AppRouter$StoreAppPage)) {
    var x = this.Sf;
    var x$2 = x$0.Sf;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "StoreAppPage";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sf;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_AppRouter$StoreAppPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jm)));
}
export { $isArrayOf_Lmealorama_AppRouter$StoreAppPage as $isArrayOf_Lmealorama_AppRouter$StoreAppPage };
var $d_Lmealorama_AppRouter$StoreAppPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$StoreAppPage, "mealorama.AppRouter$StoreAppPage", ({
  jm: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_AppRouter$StoreAppPage as $d_Lmealorama_AppRouter$StoreAppPage };
//# sourceMappingURL=mealorama.-App-Router$-Store-App-Page.js.map
